import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // 1. Send to your new API
        this.logErrorToService(error, errorInfo);
    }

    logErrorToService = async (error, errorInfo) => {
        try {
            await fetch('/api/logs/error', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message: error.toString(),
                    stack: error.stack,
                    component: 'ErrorBoundary', // Or try to parse errorInfo.componentStack
                    url: window.location.href,
                    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown',
                    meta: {
                        reactInfo: errorInfo,
                    }
                })
            });
        } catch (e) {
            // The logger failed. Do nothing.
        }
    };

    render() {
        if (this.state.hasError) {
            // Fallback UI
            return (
                <div className="min-h-screen bg-neutral-900 flex items-center justify-center p-4">
                    <div className="bg-neutral-800 p-6 rounded-xl border border-red-500/30 text-center max-w-md w-full shadow-2xl">
                        <h2 className="text-xl font-bold text-white mb-2">Ope! Something snapped.</h2>
                        <p className="text-neutral-400 mb-6 text-sm">We've logged this error and notified the squad.</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-6 py-2 bg-purple-600 hover:bg-purple-500 transition rounded-lg text-white font-bold w-full"
                        >
                            Reload App
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
